import { createContext, useContext, useState } from 'react';

const CustomerFormContext = createContext();

export const useCustomerFormContext = () => {
  const context = useContext(CustomerFormContext);
  if (!context) {
    throw new Error('useCustomerFormContext must be used within a CustomerFormProvider');
  }
  return context;
};

export const CustomerFormProvider = ({ children }) => {
  const [formDatas, setFormDatas] = useState({
    companyName: "",
    registrationNumber: "",
    phoneNumber: "",
    additionalPhoneNumber: "",
    yearsInOperation: "",
    fundingSource: "",
    website: "",
    selectedCountry: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDatas(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormDatas({
      companyName: "",
      registrationNumber: "",
      phoneNumber: "",
      additionalPhoneNumber: "",
      yearsInOperation: "",
      fundingSource: "",
      website: "",
      selectedCountry: ""
    });
  };

  const value = {
    formDatas,
    setFormDatas,
    handleInputChange,
    resetForm
  };

  return (
    <CustomerFormContext.Provider value={value}>
      {children}
    </CustomerFormContext.Provider>
  );
};
